import request from '@/utils/request'

/**
 * 查询开户行列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryAccountBank(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account.queryAccountBank',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存提现申请
 * @param {Object} data 提现申请数据
 * @returns {Promise} 返回Promise对象
 */
export function saveAccountWithdrawalApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/saveAccountWithdrawalApply',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export function listAccountWithdrawalApply(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountWithdrawalApply/listAccountWithdrawalApply',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
